module.exports = "/images/Interior---Screenshots.jpg";